import React from "react";
import toysImage from '../../images/jouets.jpg';
import CategoryPage from '../CategoryPage';

function JouetsPage() {
    const details = [
        "Boîtes à jeux électriques",
        "Voitures en tôle",
        "Poupées de collection (porcelaine, cire, tissu)",
        "Chevaux à bascule",
        "Jouets en bois (puzzles, trains, animaux)",
        "Dînette en métal ou porcelaine",
        "Soldats de plomb",
        "Poupées mannequins (années 1950-1960)",
        "Jouets mécaniques",
        "Moteurs à friction (voitures, avions, bateaux)",
        "Mignons et figurines en biscuit",
        "Cubes et blocs en bois",
        "Jeux de société vintage",
        "Toupies et yoyos en bois",
        "Marionnettes en bois ou tissu",
        "Carnets de coloriage et crayons anciens",
        "Boîtes à musique",
        "Malles de poupées et accessoires miniatures",
        "Miniatures de train électrique",
        "Peluches anciennes (en mohair ou laine)",
    ];

    return (
        <CategoryPage
            title="Jouets Anciens"
            image={toysImage}
            description="J’ai le privilège de traiter avec des personnes qui détiennent des objets chargés d’histoires et de souvenirs du passé. Chaque jouet que j’acquiers, qu’il s’agisse d’une boîte à jeux électriques nostalgique, d’une voiture en tôle ayant traversé les années, d’une poupée ancienne aux détails fins, de jouets en bois aux formes intemporelles, ou d’un cheval à bascule ayant bercé plusieurs générations, porte en elle une part précieuse de notre mémoire collective. Passionné par la préservation de ces témoignages du temps, je m’engage à valoriser chaque pièce avec soin et respect. Si vous avez des trésors à partager, n’hésitez pas à me contacter."
            details={details}
        />
    );
}

export default JouetsPage;
